export const colorPalette  = {
    colorPrimary : '#131415', // black
    colorAccent : '#2663FF', // blue
    colorLightBlue: '#EBF1FB', //light shade blue
    colorGrayishBlue: '#989EA4', // grayish blue
    colorDarkGray: '#4A4F54', // dark grey
    colorLightGray: '#F0F0F0', // light gray
    colorGray: '#8F8F8F', // gray
    colorLightPinkishRed: '#f8d7da', // light pinkish red
    colorDarkRed:  '#721c24', // dark red
    colorPureWhite: '#ffff', // Pure white
    colorPureBlack: '#000000', // pure black
    colorVeryDarkGray: '#242424', // Very dark  gray
    colorLightMintGreen:  '#C8E6C9', // light mint green
    colorSoftPinkRed: '#f69697', // Soft pinkish red
    colorLightYellow: '#FFF8E1', // light yellow (draft / in review)
    colorVibrantYellow: '#ED6C02', // vibrant yellow/amber text
    colorVibrantGreen: '#2E7D32', // vibrant green 
    colorPureRed: '#FF0000', // pure red
    colorVibrantMediumBlue: '#2663FF', // Vibrant medium blue
    colorVeryLightGray: '#F5F5F6', // very light gray
    colorSoftLightGray: '#E5E7E8', // soft light gray
    colorLightGrayishBlue: '#D6D8DB', // light grayish-blue
    colorOffWhite: '#f5f5f5', // Off,
    error: "#d32f2f",
    colorDeleteRed: "#C62828",
}
